<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId"/>
    <a-card :bordered="false" v-if="currentRobotId">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="客户端ID">
                <a-select v-model="queryParam.condition_sub_id" placeholder="数据互通模式可筛选" allowClear>
                  <a-select-option
                    v-for="option in robotList"
                    :key="option.id"
                    :value="option.id"
                  >ID：{{option.id}}，昵称：{{option.nickname}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="1">用户UID</a-select-option>
                  <a-select-option value="2">微信ID</a-select-option>
                  <a-select-option value="3">微信昵称</a-select-option>
                  <a-select-option value="4">商品ID</a-select-option>
                  <a-select-option value="5">推广位PID</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operator"></div>
      <s-table ref="table" rowKey="id" :columns="columns" :data="loadData" :scroll="{x:1500}">
        <span slot="serial" slot-scope="text" v-line-clamp="1">
          {{text}}
        </span>
        <span slot="goodTitle" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span v-line-clamp="1">{{ text || '无' }}</span>
          </a-tooltip>
        </span>
        <span slot="userInfo" slot-scope="scoped">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ scoped.relation_to_member.nickname }}</span>
            </template>
            <span v-line-clamp="1">昵称：{{ scoped.relation_to_member.nickname  || '无' }}</span>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ scoped.relation_to_member.wxid }}</span>
            </template>
            <span v-line-clamp="1">微信ID：{{scoped.relation_to_member.wxid}}</span>
          </a-tooltip>
          <span v-line-clamp="1">
            UID：{{scoped.relation_to_member.uid}}
          </span>
        </span>
        <span slot="goodsInfo" slot-scope="scoped">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ scoped.title }}</span>
            </template>
            <span v-line-clamp="1" style="color:#1890ff">商品标题：{{ scoped.title  || '无' }}</span>
          </a-tooltip>
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ scoped.iid }}</span>
            </template>
            <span v-line-clamp="1">
              <a-tag color="green">商品ID：{{scoped.iid}}</a-tag>
            </span>
          </a-tooltip>
          <span v-line-clamp="1">
            <a-tag color="blue">付款金额：{{scoped.realprice}}元</a-tag>
          </span>
        </span>
        <span slot="commissionInfo" slot-scope="scoped">
          <span v-line-clamp="1">
            <a-tag color="red">
              总佣金：{{scoped.commission}}
            </a-tag>
          </span>
          <span v-line-clamp="1">    
            <a-tag color="pink">
              佣金比例：{{scoped.commissionrate}}
            </a-tag>
          </span>
        </span>
        <span slot="couponInfo" slot-scope="scoped">
          <span v-line-clamp="1">
            <a-tag color="cyan">
              查券时间：{{scoped.addtime}}
            </a-tag>
          </span>
          <span v-line-clamp="1">    
            <a-tag color="orange">
              券面额：{{scoped.quanmz}}
            </a-tag>
          </span>
        </span>
        <span slot="pid" slot-scope="text">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <span v-line-clamp="1">{{ text || '无' }}</span>
          </a-tooltip>
        </span>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import { STable } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import DeviceApi from '@/api/device'
import CouponApi from '@/api/coupon'
import { PageView } from '@/layouts'
import { ExceptionPage } from '@/components'
export default {
  name: 'CapitalLog',
  components: {
    PageView,
    STable,
    SearchRobot,
    ExceptionPage
  },
  data() {
    return {
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      robotList:[],
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          scopedSlots: { customRender: 'serial' },
          width:80,
          fixed:'left'
        },
        {
          title: '机器人ID',
          dataIndex: 'sub_id',
          width:100,
          fixed:'left'
        },
        {
          title: '用户信息',
          scopedSlots:{customRender:'userInfo'},
          width:200
        },
        {
          title: '商品信息',
          scopedSlots: { customRender: 'goodsInfo' },
          width:200,
        },
        {
          title: 'pid(推广位)',
          dataIndex: 'pid',
          scopedSlots: { customRender: 'pid' },
          width:180,
        },
        {
          title: '佣金信息',
          scopedSlots: { customRender: 'commissionInfo' },
          width:170
        },
        {
          title: '查券信息',
          scopedSlots: { customRender: 'couponInfo' },
          width:170
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return CouponApi.searchCouponLog(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId
          })
        )
      },
    }
  },
  created() {
    this.getRobotList()
  },
  methods: {
    onChangeRobotId(id) {
      this.currentRobotId = id
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
    },
    // toggleAdvanced() {
    //   this.advanced = !this.advanced
    // },
    getRobotList(){
      DeviceApi.getList({pageSize:2000}).then((res)=>{
        this.robotList = res.data
      })
    },
  }
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
</style>
